import { useState } from "react";
import { Get, Set } from "../../../../../../Request";
import { useDispatch, useSelector } from "react-redux";
import {
  compaireTwoDate,
  ToDateJalali,
  RenderPrice,
  addTime,
} from "../../../../../Common/Function/index";
import moment from "jalali-moment";
import { useParams } from "react-router";

export const useTableWeekCount = () => {
  const dispatch = useDispatch();
  const checkSecondPrice = data => {
    return data.second_price;
  };
  const { slug } = useParams();
  const { user_type, user, basket } = useSelector(state => state);
  const [week, setWeek] = useState({
    week: true,
  });
  const [days, setDays] = useState();
  const [loadingWeek, setLoadingWeek] = useState(true);
  const [loadingSans, setLoadingSans] = useState(false);
  const [modal, setModal] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState();
  const [list, setList] = useState();
  const [loading, setloading] = useState(true);
  const getWeek = data => {
    setLoadingWeek(true);
    Get({
      url: "/timetable/sans_weektable",
      data: { ...data, item_id: slug },
    }).then(res => {
      setWeek(res);
      setDays([
        "Saturday",
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
      ]);
      setLoadingWeek(false);
    });
  };
  const convertDay = day => {
    switch (day) {
      case "Wednesday":
        return "چهارشنبه";
      case "Thursday":
        return "پنج شنبه";
      case "Friday":
        return "جمعه";
      case "Monday":
        return "دوشنبه";
      case "Tuesday":
        return "سه شنبه";
      case "Saturday":
        return "شنبه";
      case "Sunday":
        return "یک شنبه";
      default:
        break;
    }
  };
  const statusHandler = (sans, day) => {
    let result = {};

    if (
      compaireTwoDate(day, moment().format("YYYY-MM-DD"), sans.time) &&
      compaireTwoDate(day, moment().format("YYYY-MM-DD"), sans.time) != "today"
    ) {
      if (sans.pending) {
        sans.pending.map(pend => {
          if (pend.id != "manager") {
            result = {
              text: "مشاهده رزرو",
              style: {
                background: "#E42A3F",
                color: "white",
                padding: "14px",
                borderStyle: "dashed",
                borderColor: "#dddddd",
                borderWidth: 1,
                cursor: "pointer",
                fontWeight: "200",
              },
              status: "show",
              show: true,
            };
          }
        });
      } else {
        result = {
          text: "گذشته ",
          style: {
            backgroundColor: "#fafafa",
            color: "#ccc",
            padding: "14px",
            fontWeight: "200",
            cursor: "not-allowed",
          },
          status: false,
        };
      }
    } else {
      if (sans.pending) {
        sans.pending.map(pend => {
          if (pend.id == "manager") {
            result = {
              text: "رزرو توسط مدیر",
              style: {
                background: "#E42A3F",
                color: "white",
                padding: "14px",
                borderStyle: "dashed",
                borderColor: "#dddddd",
                borderWidth: 1,
                cursor: "pointer",
                fontWeight: "200",
              },
              status: "cancel",
              cancel: true,
            };
          } else {
            if (sans.count == 0) {
              result = {
                text: "اتمام ظرفیت",
                style: {
                  background: "#E42A3F",
                  color: "white",
                  padding: "14px",
                  borderStyle: "dashed",
                  borderColor: "#dddddd",
                  borderWidth: 1,
                  cursor: "pointer",
                  fontWeight: "200",
                },
                status: true,
                show: true,
              };
            } else {
              result = {
                text: RenderPrice(sans),
                style: {
                  background: "#DDFFE8",
                  color: "#05974d",
                  padding: "14px",
                  borderStyle: "dashed",
                  borderColor: "#dddddd",
                  borderWidth: 1,
                  cursor: "pointer",
                  fontWeight: "200",
                },
                status: checkSecondPrice(sans) ? "second_price" : true,
                show: true,
              };
            }
          }
        });
      } else {
        result = {
          text: RenderPrice(sans),
          style: {
            background: "#DDFFE8",
            color: "#05974d",
            padding: "14px",
            borderStyle: "dashed",
            borderColor: "#dddddd",
            borderWidth: 1,
            cursor: "pointer",
            fontWeight: "200",
          },
          status: checkSecondPrice(sans) ? "second_price" : true,
        };
      }
    }

    if ("status" in sans) {
      if (sans.status == "last") {
        result = {
          text: "گذشته ",
          style: {
            backgroundColor: "#fafafa",
            color: "#ccc",
            padding: "14px",
            fontWeight: "200",
            cursor: "not-allowed",
          },
          status: false,
        };
      } else if (sans.status == "future") {
        result = {
          text: "بدون قرارداد ",
          style: {
            backgroundColor: "#fafafa",
            color: "#ccc",
            padding: "14px",
            fontWeight: "200",
            cursor: "not-allowed",
          },
          status: false,
        };
      }
    }

    return result;
  };
  const checkTime = () => {};
  const getDate = (date, week, jalali) => {
    if (week && date) {
      if (jalali) {
        return week.data[date].date;
      }
      return `${ToDateJalali(week.data[date].date).split("/")[1]}/${
        ToDateJalali(week.data[date].date).split("/")[2]
      }`;
    }
  };
  const getYear = (date, week) => {
    if (date && week) {
      return `${ToDateJalali(week.data[date].date).split("/")[0]}`;
    }
  };

  const checkCurrentWeek = data => {
    let result = false;
    if (data) {
      days.map(day => {
        if (data.data[day].date == new Date().toISOString().split("T")[0]) {
          result = true;
        }
      });
    }

    return result;
  };

  const changeStatus = async (data, item, day, currentDay) => {
    if (statusHandler(data, day)["cancel"]) {
      setModal({
        data: data,
        day: day,
        currentDay,
        status: "cancel",
      });
    } else if (statusHandler(data, day)["show"]) {
      setModal({
        data: data,
        day: day,
        currentDay,
        status: "show",
      });
    } else {
      setModal({
        data: data,
        day: day,
        currentDay,
      });
    }
  };
  const reserveByManager = async data => {
    setLoadingBtn(data.sans_id);
    await Set({
      url: "/item/new_contract_admin",
      data: { item_id: slug, ...data },
    }).then(() => {
      // selectDay(form.day_details);
      setLoadingBtn(false);
    });
  };
  const cancelByManager = async data => {
    setLoadingBtn(data.sans_id);
    await Set({
      url: "/item/cansel_contract_admin",
      data: { item_id: slug, ...data },
    }).then(() => {
      // selectDay(form.day_details);
      getWeek();
      setLoadingBtn(false);
    });
  };
  const updateTimeTable = async data => {
    // setLoading({ ...loading, all: true, btnLoading: true });
    setLoadingBtn(data.sans_id);
    await Set({
      url: "/item/update_timetable",
      data: { item_id: slug, ...data },
    }).then(() => {
      // setLoading({ ...loading, all: true, btnLoading: false });
      // selectDay(form.day_details);
      setLoadingBtn(false);
      setModal(false);
    });
  };

  const showReserve = async data => {
    setloading(true);
    await Get({
      url: "/reserve/get_sanswcount_reserve",
      data: { ...data },
    }).then(response => {
      setList(response);
      setloading(false);
    });
  };
  return {
    loadingWeek,
    week,
    getWeek,
    days,
    convertDay,
    statusHandler,
    getDate,
    changeStatus,
    loadingSans,
    checkCurrentWeek,
    getYear,
    showReserve,
    updateTimeTable,
    reserveByManager,
    modal,
    setModal,
    loadingBtn,
    cancelByManager,
  };
};
